var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "9.034%",
    y1: "54.872%",
    x2: "93.312%",
    y2: "44.849%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1E3F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#294389",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.118 24.556H4.048a3.465 3.465 0 01-3.465-3.465V4.02A3.465 3.465 0 014.05.556h30.069a3.465 3.465 0 013.465 3.465v17.07a3.465 3.465 0 01-3.465 3.465z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.255 8.16L10.9 14.113 9.947 9.05c-.112-.565-.553-.891-1.043-.891h-3.85L5 8.414c.79.171 1.688.448 2.232.744.333.18.428.339.538.768l1.804 6.98h2.391l3.666-8.746h-2.376m3.347 0l-1.872 8.746h2.263l1.87-8.746h-2.261m12.972 2.362l.685 3.285h-1.877l1.192-3.285m-.332-2.362c-.434 0-.8.253-.963.641l-3.394 8.105h2.374l.473-1.306h2.901l.274 1.306H33L31.174 8.16h-1.932m-9.761 2.73c-.016 1.26 1.122 1.963 1.98 2.38.881.43 1.177.705 1.174 1.088-.007.587-.703.846-1.355.856-1.137.018-1.797-.307-2.323-.552l-.41 1.916c.528.243 1.504.455 2.516.464 2.376 0 3.931-1.173 3.94-2.992.009-2.308-3.193-2.435-3.171-3.467.007-.313.306-.647.96-.732.324-.042 1.217-.075 2.23.391l.398-1.854A6.063 6.063 0 0023.303 8c-2.236 0-3.81 1.189-3.822 2.89",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.075 1A2.928 2.928 0 0137 3.925v17.15A2.928 2.928 0 0134.075 24H3.925A2.928 2.928 0 011 21.075V3.925A2.928 2.928 0 013.925 1h30.15zm0-1H3.925A3.925 3.925 0 000 3.925v17.15A3.925 3.925 0 003.925 25h30.15A3.925 3.925 0 0038 21.075V3.925A3.925 3.925 0 0034.075 0z",
    fill: "#E3EAED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.ea9788b66d303b33b2a737d5d49e4d4e.svg";
export { ForwardRef as ReactComponent };